
import { lightBeeTheme } from './theme/beeTheme';
import { SettingsProvider } from "./settings/settingsProvider";
import { FavouritesProvider } from "./favourites/favouritesProvider";
import { PageChooser } from "./nav/pageChooser";
import { DeviceProvider } from "./device/deviceProvider";
import { ThemeProvider } from "@mui/material/styles"; // <-- use MUI’s ThemeProvider

export const Home = () => {

    return <DeviceProvider>
        <ThemeProvider theme={lightBeeTheme}>
            <FavouritesProvider>
                <SettingsProvider>
                    <PageChooser />
                </SettingsProvider>
            </FavouritesProvider>
        </ThemeProvider>
    </DeviceProvider>
}